<template>
  <div class="w-full">
    <!-- member count and auto reply section  -->
    <section class="flex items-center justify-between mt-5">
      <div class="text-xl font-medium">
        <h4>
          Found <span class="font-semibold">{{ allUsersDmDetails.length }}</span> Members
        </h4>
      </div>
    </section>
    <!-- tweet rendering section  -->
    <section v-for="(dms, index) in allUsersDmDetails" :key="index" >
      <div v-if="dms.allDms" class="w-full mt-5 bg-white p-5 shadow-sm rounded-md">
         <dm-render :activityInfo="dms" :index="index" />
      </div>
    </section>
  </div>
</template>

<script>
import utils from '@/services/utils';
import DmRender from './DmRender.vue';

export default {
  name: 'Dms',
  layout: 'admin',
  components: { DmRender },
  data() {
    return {
      tweetCount: 108,
    };
  },
  computed: {
    currentSegemnt: {
      get() {
        return this.$store.state.connect.currentSegment;
      },
      set(newValue) {
        return newValue;
      },
    },
    allUsersDmDetails: {
      get() {
        console.log(this.$store.state.connect.allUsersDmDetails);
        return this.$store.state.connect.allUsersDmDetails;
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  watch: {
    currentSegemnt() {
      this.fetchDmList(this.currentSegemnt);
      this.fetchDmCount(this.currentSegemnt);
    },
  },
  mounted() {
    if (this.$route.query.courseId) {
      this.fetchDmList(this.$route.query.courseId);
      this.fetchDmCount(this.$route.query.courseId);
    } else if (this.currentSegemnt) {
      this.fetchDmList(this.currentSegemnt);
    }
  },
  methods: {
    async fetchDmList(currentSegemnt) {
      try {
        this.$store.commit('toggleLoading', true);
        await this.$store.dispatch('fetchMembersDmList', currentSegemnt);
        this.$store.commit('toggleLoading', false);
      } catch (error) {
        this.$store.commit('toggleLoading', false);
        utils.setStatusMsg(this, error?.message || 'something went wrong');
      }
    },
    async fetchDmCount(currentSegemnt) {
      try {
        await this.$store.dispatch('fetchMembersDmCount', currentSegemnt);
      } catch (error) {
        utils.setStatusMsg(this, error?.message || 'something went wrong');
      }
    },
  },
};
</script>
